import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { AutoComplete } from 'primeng/autocomplete';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';

export interface ClientSuggestion {
  clientName: string;
  administratorName?: string;
  clientUuid?: string;  // ✅ ÚJ
  mainContactPersonUuid?: string;  // ✅ ÚJ
}

@Component({
  selector: 'app-formly-client-autocomplete',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, AutoComplete, FormlyModule],
  template: `
    <div class="field">
      @if (props.label) {
        <label [for]="field.key" class="block mb-2">
          {{ props.label }}
          @if (props.required) {
            <span class="text-red-500">*</span>
          }
        </label>
      }
      <p-autocomplete
        [forceSelection]="true"
        [suggestions]="props.suggestions"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [field]="'clientName'"
        [dropdown]="false"
        [minLength]="props.minLength || 2"
        [delay]="300"
        [style]="{ width: '100%' }"
        (onSelect)="onClientSelected($event)"
        (completeMethod)="props.searchObject(props, $event, field)"
        placeholder="Ügyfél keresése név alapján (min. 2 karakter)">
        <ng-template let-client pTemplate="item">
          <div class="flex flex-column gap-1">
            <div class="font-medium">{{ client.clientName }}</div>
            @if (client.administratorName) {
              <small class="text-gray-500">
                Kapcsolattartó: {{ client.administratorName }}
              </small>
            }
          </div>
        </ng-template>
      </p-autocomplete>
    </div>
  `,
})
export class FormlyClientAutoCompleteComponent extends FieldType<FieldTypeConfig> {
  // ✅ ÚJ METÓDUS - teljes objektumot adjuk át
  onClientSelected(event: any) {
    console.log('🔍 Autocomplete selected:', event); // DEBUG
    
    if (event && this.props.onSelect) {
      // A teljes objektumot adjuk át, NEM csak a value-t
      this.props.onSelect({
        value: event.value,  // Ez a teljes ClientSuggestion objektum
        originalEvent: event.originalEvent,
      });
    }
  }
}